module.exports = __webpack_public_path__ + "fonts/HKGrotesk-Bold.80e0d19.woff2";